import { render, staticRenderFns } from "./InfoGes.vue?vue&type=template&id=3032b73c"
import script from "./InfoGes.vue?vue&type=script&lang=js"
export * from "./InfoGes.vue?vue&type=script&lang=js"
import style0 from "./InfoGes.vue?vue&type=style&index=0&id=3032b73c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports